export default "__VITE_ASSET__BRWBuFqN__"